import { defineStore } from "pinia";
import Vue, { ref } from "vue";
import axios from "axios";
import i18n from "@/i18n";
import { POSITION, TYPE } from "vue-toastification";
import { Family, FamilyInfo } from "@/model/family";

export const useFamilyStore = defineStore("family", () => {
  const family = ref<FamilyInfo>({
    id: -1,
    molecules: [],
    name: "",
    synergies: [],
  });
  const families = ref<Family[]>([]);

  const getFamilies = async () => {
    await axios
      .get<Family[]>("/family")
      .then((res) => (families.value = res.data));
  };
  const getFamilyById = async (id: number) => {
    await axios
      .get<FamilyInfo>(`/family/${id}`)
      .then((res) => (family.value = res.data));
  };
  const addFamily = async () => {
    await axios
      .post<Family>("/family", { ...family.value })
      .then((res) => {
        families.value.push(res.data);
        Vue.$toast(i18n.t("family.toast.add.success"), {
          timeout: 2000,
          position: POSITION.TOP_CENTER,
          type: TYPE.SUCCESS,
        });
      })
      .catch(() => {
        Vue.$toast(i18n.t("family.toast.add.error"), {
          timeout: 2000,
          position: POSITION.TOP_CENTER,
          type: TYPE.ERROR,
        });
      });
  };

  const updateFamily = async () => {
    await axios
      .patch<FamilyInfo>(`/family/${family.value.id}`, family.value)
      .then(() => {
        Vue.$toast(i18n.t("family.toast.update.success"), {
          timeout: 2000,
          position: POSITION.TOP_CENTER,
          type: TYPE.SUCCESS,
        });
      })
      .catch(() => {
        Vue.$toast(i18n.t("family.toast.update.error"), {
          timeout: 2000,
          position: POSITION.TOP_CENTER,
          type: TYPE.ERROR,
        });
      });
  };

  const deleteFamily = async (id) => {
    await axios
      .delete(`/family/${id}`)
      .then((res) => {
        const idx: number = families.value.findIndex(
          (item) => item.id === res.data.id
        );
        families.value.splice(idx, 1);
        Vue.$toast(i18n.t("family.toast.delete.success"), {
          timeout: 2000,
          position: POSITION.TOP_CENTER,
          type: TYPE.SUCCESS,
        });
      })
      .catch(() => {
        Vue.$toast(i18n.t("family.toast.delete.error"), {
          timeout: 2000,
          position: POSITION.TOP_CENTER,
          type: TYPE.ERROR,
        });
      });
  };

  return {
    family,
    families,
    getFamilies,
    getFamilyById,
    addFamily,
    updateFamily,
    deleteFamily,
  };
});
